import { jsxs, jsx } from 'react/jsx-runtime';
import { styled } from '@mui/material';
import { useButtonContext } from './ButtonContext.js';

const ButtonLoading = styled("div")({
    display: "flex",
    flexWrap: "nowrap",
    position: "absolute",
    alignItems: "center",
    justifyContent: "center",
    visibility: "visible",
    inset: 0,
});
const LoadingDot = styled("div")(({ theme, $size, $variant, $color }) => (Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({ background: theme.palette.ui12, width: 8, height: 8, borderRadius: 6, margin: theme.spacing(0, 0.5), visibility: "visible", animation: "dots 1.5s infinite" }, ($size === "sm" && {
    width: 4,
    height: 4,
    borderRadius: 3,
    margin: theme.spacing(0, 0.25),
})), ($color === "secondary" &&
    $variant === "default" && {
    backgroundColor: theme.palette.text.secondary,
})), ($color === "primary" &&
    ($variant === "outlined" || $variant === "ghost") && {
    backgroundColor: theme.palette.primary[800],
})), ($color === "error" &&
    ($variant === "outlined" || $variant === "ghost") && {
    backgroundColor: theme.palette.failure[700],
})), ($color === "secondary" &&
    ($variant === "outlined" || $variant === "ghost") && {
    backgroundColor: theme.palette.text.secondary,
})), { "&:nth-child(2)": {
        animationDelay: "500ms",
    }, "&:nth-child(3)": {
        animationDelay: "1000ms",
    }, "@keyframes dots": {
        "0%": {
            opacity: 1,
        },
        "30%": {
            opacity: 0.25,
        },
        "70%": {
            opacity: 0.5,
        },
        "100%": {
            opacity: 1,
        },
    } })));
const ButtonLoader = () => {
    const { size, color, variant } = useButtonContext();
    return (jsxs(ButtonLoading, { children: [jsx(LoadingDot, { "$color": color, "$size": size, "$variant": variant }), jsx(LoadingDot, { "$color": color, "$size": size, "$variant": variant }), jsx(LoadingDot, { "$color": color, "$size": size, "$variant": variant })] }));
};

export { ButtonLoader };
//# sourceMappingURL=ButtonLoader.js.map
